var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-container" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-25 md-xsmall-size-100 md-size-25",
        },
        [
          _c(
            "md-card",
            { staticClass: "md-card-profile" },
            [
              _c(
                "div",
                {
                  staticClass: "md-card-avatar upload-container",
                  on: {
                    mouseover: function ($event) {
                      _vm.showUploadButton = true
                    },
                    mouseleave: function ($event) {
                      _vm.showUploadButton = false
                    },
                  },
                },
                [
                  !_vm.photoPreview
                    ? _c("img", {
                        staticClass: "profile-image",
                        attrs: {
                          src:
                            _vm.member.photoUrl !== null
                              ? _vm.member.photoUrl
                              : _vm.$root.defaultPhotoUrl,
                          alt: "",
                        },
                        on: { error: _vm.$_setDefaultBrokenImage },
                      })
                    : _vm._e(),
                  _vm.photoPreview
                    ? _c("img", {
                        staticClass: "profile-image",
                        attrs: { src: _vm.photoPreview, alt: "" },
                        on: { error: _vm.$_setDefaultBrokenImage },
                      })
                    : _vm._e(),
                  _vm.showUploadButton && _vm.canUpdateMember
                    ? _c("div", [
                        _c("input", {
                          ref: "photoInput",
                          attrs: {
                            accept:
                              "image/png, image/gif, image/jpeg, image/jpg, image/gif, image/bmp, image/webp",
                            hidden: "",
                            type: "file",
                          },
                          on: { change: _vm.onPhotoSelected },
                        }),
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "custom-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.photoInput.click()
                                },
                              },
                            },
                            [_vm._v("Update Photo")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "md-card-content",
                { staticClass: "card-container" },
                [
                  _c("h6", { staticClass: "category text-gray" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.displayRole) +
                        "\n                    "
                    ),
                  ]),
                  _c("span", { staticClass: "card-description" }, [
                    _vm._v(
                      "\n                        Date Joined: " +
                        _vm._s(
                          _vm._f("dateFormat")(
                            _vm.member.dateJoined,
                            _vm.DATE_TYPES.standardDate
                          )
                        ) +
                        "\n                    "
                    ),
                  ]),
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.displayName) +
                        "\n                    "
                    ),
                  ]),
                  _vm.canRequestDeviceLog(_vm.member.deviceType)
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-primary text-center",
                          on: {
                            click: function ($event) {
                              return _vm.handleRequestDeviceLog(
                                _vm.member.publicUserId
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Request Device Logs\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.member.disabledDate === null &&
                  _vm.user.publicUserId !== _vm.member.publicUserId &&
                  _vm.canUpdateMember
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-default text-center",
                          on: {
                            click: function ($event) {
                              return _vm.updateTeamMemberStatus(
                                _vm.member.publicUserId,
                                "disable"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Disable Member\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.member.disabledDate != null &&
                  _vm.user.publicUserId != _vm.member.publicUserId &&
                  _vm.canUpdateMember
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-default text-center md-success",
                          on: {
                            click: function ($event) {
                              return _vm.updateTeamMemberStatus(
                                _vm.member.publicUserId,
                                "enable"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Enable Member\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.member.disabledDate == null &&
                  _vm.member.isLockedOut &&
                  _vm.user.publicUserId != _vm.member.publicUserId &&
                  _vm.canUpdateMember
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-default text-center md-warning",
                          on: {
                            click: function ($event) {
                              return _vm.updateTeamMemberStatus(
                                _vm.member.publicUserId,
                                "unlock"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Unlock Member\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-medium-size-75 md-xsmall-size-100 md-size-75",
        },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-content",
                { staticClass: "custom-card-content" },
                [
                  _c(
                    "tabs",
                    {
                      ref: "memberTab",
                      staticClass: "custom-tab-list",
                      attrs: {
                        "tab-name": _vm.tabs,
                        "message-text":
                          "There are pending changes. Are you sure you want to switch tabs?",
                        "selected-panel": _vm.activeTab,
                        "show-prompt": true,
                        "color-button": "primary",
                      },
                      on: { "prompt-response": _vm.handleTabSwitch },
                    },
                    [
                      _c(
                        "template",
                        { slot: "tab-pane-1" },
                        [
                          _c("member-details", {
                            ref: "details",
                            attrs: {
                              data: _vm.member,
                              "is-allowed-to-update": _vm.canUpdateMember,
                            },
                            on: { updated: _vm.handleUpdate },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "tab-pane-2" },
                        [
                          _c("member-document", {
                            ref: "documents",
                            attrs: {
                              data: _vm.member,
                              "is-allowed-to-update": _vm.canUpdateMember,
                            },
                            on: { updated: _vm.handleUpdate },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "tab-pane-3" },
                        [
                          _c("member-accounting-details", {
                            ref: "accounts",
                            attrs: {
                              data: _vm.member,
                              "is-allowed-to-update": _vm.canEditAccountsTab,
                            },
                            on: { updated: _vm.handleUpdate },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "tab-pane-4" },
                        [
                          _c("member-roster-configuration", {
                            ref: "rosterConfiguration",
                            attrs: {
                              "public-user-id": _vm.$route.params.publicUserId,
                              "roster-configuration-data":
                                _vm.rosterConfigurationData,
                            },
                            on: {
                              rosterConfigurationUpdated:
                                _vm.handleRosterConfigurationUpdated,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.canViewHistory
            ? _c(
                "md-card",
                { staticClass: "history-section" },
                [
                  _c(
                    "md-card-content",
                    [
                      _c("history-component", {
                        ref: "historyComponent",
                        attrs: {
                          "view-type":
                            _vm.CHANGE_HISTORY_VIEW_TYPES.TEAM_MEMBER,
                          "entity-id": _vm.member.userId || 0,
                          "page-size": 15,
                          title: "Profile Change History",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }